// ⋯ から開く Menu の paper (design-book 02-components/popover-menu.md)。薬剤師の録音後の ⋯
// (PostRecordingMoreMenu) と管理栄養士の記録の ⋯ (NutritionRecordMenu) が同じ文法で参照する。
// 値の変更は本書 → ここの 1 箇所で両者に波及させる。
import { RADIUS } from '@/shared/styles/radii'
import { FONT_WEIGHT, UI_FONT_SIZE } from '@/shared/styles/typography'

import { colorTokens } from './colorTokens'

export const NOTION_MENU_PAPER_SX = {
  minWidth: 220,
  borderRadius: `${RADIUS.lg}px`,
  boxShadow: colorTokens.shadow.popover,
  '& .MuiMenuItem-root': {
    fontSize: UI_FONT_SIZE.bodySm,
    fontWeight: FONT_WEIGHT.medium,
    color: colorTokens.fg.default,
    px: 1.5,
    py: 0.75,
    minHeight: 'auto',
  },
} as const
